<script>
  import { page } from "$app/stores";
  import CardProducts from "$lib/components/products/CardProducts.svelte";

  export let data;
</script>

<svelte:head>
  <title>RCM - {data.slug?.replaceAll("-", " ").toUpperCase()}</title>
</svelte:head>

<div class="body">
  {#if data.banner}
    <div class="banner">
      <picture>
        <source srcset={data.banner.x2} media="(min-width: 769px)" />
        <source srcset={data.banner.x1} media="(max-width: 768px)" />
        <img src={data.banner.x1} alt={`site: ${$page.url}`} />
      </picture>
    </div>
  {/if}
  <h1>{data.slug?.replaceAll("-", " ")}</h1>
  {#if data.products}
    <ul class="products">
      {#each data.products as product}
        <CardProducts {product} />
      {/each}
    </ul>
  {/if}
</div>

<style>
  .body {
    width: 100%;
    margin: 15rem auto 0 auto;
  }
  .body h1 {
    font-size: clamp(5rem, 5vmax, 10rem);
    width: 95svw;
    max-width: 150rem;
    margin: 3rem auto;
    text-transform: capitalize;
    font-family: sirenia;
    color: var(--orange);
  }
  .banner {
    width: 95svw;
    max-width: 150rem;
    margin: 0 auto;
    aspect-ratio: 2/1;
    border-radius: 3rem;
  }
  .banner img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 3rem;
  }
  .products {
    width: 95svw;
    max-width: 150rem;
    gap: 2rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, 34rem);
    justify-content: space-between;
    justify-items: center;
    padding-bottom: 15rem;
  }
  @media (max-width: 767px) {
    .body h1 {
      text-align: center;
    }
    .products {
      grid-template-columns: minmax(200px, 280px);
      gap: 1rem;
      justify-content: center;
    }
  }
</style>
